var exports = {
  "nw": "outerContainer__iY934Y",
  "WH": "innerContainer__mxK8FR",
  "mr": "highlighted__jJGw_G",
  "U1": "headerRow__U6n1NK",
  "IB": "commentBorder__V4zML9",
  "Nv": "commentBorderAuthor__AZgsb2",
  "P": "editorWrapper__GZoexg",
  "iz": "modernUxContainer__B1xcVn",
  "pj": "modernUxBody__gfawol",
  "OQ": "modernUxViewerWrapper__0LpEy8",
  "zm": "modernUxEditButton__a2kGuJ",
  "Qe": "avatarOuterWrapper__HKusAe",
};

module.exports = exports;
